import { SubText, TitleH2 } from 'components/Common/Typography'
import LinkButton from 'components/LinkButton'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { FC } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'

const Best: FC<{ data; setContactPopup }> = ({ data, setContactPopup }) => {
  const router = useRouter()
  const PageUrlCheck = router.query.path === 'react-native-app-development'
  return (
    <section
      className="bestSection"
      style={{
        background: `url(${data?.img})no-repeat scroll
    0 0 / cover`,
      }}
    >
      <Container>
        <div className="best_inner_cnt">
          <Row>
            <Col xl={6} className="position-relative">
              <TitleH2 className="mb-4 text_black" text={data?.title} />
              <SubText className="mb-4" text={data?.subTitle} />
              <Row>
                {/* {iconData.map(({ Icontitle, iconimg }) => { */}
                {data?.box?.map((b, i) => {
                  return (
                    <Col key={i} xs={6} className="pt-4 text-center">
                      <Image
                        src={b.iconimg}
                        width={50}
                        height={50}
                        alt="best"
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                        }}
                      />
                      <div className="text_para_large pt-3">
                        {b.Icontitle}
                      </div>
                    </Col>
                  )
                })}
              </Row>
              {!PageUrlCheck
                ? data?.blueButtonText1 && (
                    <div className="mt-5 position-absolute btnHire">
                      <LinkButton
                        className="text-decoration-none"
                        onClick={() => setContactPopup(true)}
                        role="button"
                        tabIndex={0}
                        path="javscript:void(0)"
                      >
                        <span>
                          {data?.blueButtonText1} {data?.buttonText2}
                        </span>
                      </LinkButton>
                    </div>
                  )
                : ''}
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  )
}

export default Best
